var _defs, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNuo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1559 682",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 238,
    y1: 1099.75,
    x2: 704,
    y2: 1099.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#85b8f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88acf7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 785,
    y1: 1099.75,
    x2: 1251,
    y2: 1099.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#88a8f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8b97f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1315,
    y1: 1100,
    x2: 1797,
    y2: 1100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8c94f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f87f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 531,
    y1: 66.5,
    x2: 664,
    y2: 66.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#89a4f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8aa0f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 892,
    y1: 66.5,
    x2: 1025,
    y2: 66.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8c96f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c92f7"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "nuo logo 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M703.07,1105.09q.42-7,.43-14.09c0-128.41-104.09-232.5-232.5-232.5S238.5,962.59,238.5,1091q0,7.17.43,14.24L238,1285a56,56,0,0,0,112,0V1091a121,121,0,0,1,242,0v198.57l.19-.12A56,56,0,0,0,704,1285Z",
    transform: "translate(-238 -659)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1250.07,1094.41q.42,7,.43,14.09c0,128.41-104.09,232.5-232.5,232.5s-232.5-104.09-232.5-232.5q0-7.17.43-14.24L785,914.5a56,56,0,0,1,112,0v194a121,121,0,0,0,242,0V909.93l.19.12A56,56,0,0,1,1251,914.5Z",
    transform: "translate(-238 -659)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1556,859c-133.1,0-241,107.9-241,241s107.9,241,241,241,241-107.9,241-241S1689.1,859,1556,859Zm0,371a130,130,0,1,1,130-130A130,130,0,0,1,1556,1230Z",
    transform: "translate(-238 -659)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 597.5,
    cy: 66.5,
    r: 66.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 958.5,
    cy: 66.5,
    r: 66.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNuo);
export default __webpack_public_path__ + "static/media/nuo.a777d73399b3362423c97d03bdb30101.svg";
export { ForwardRef as ReactComponent };